import {Component, OnInit} from '@angular/core';
import {PlatformService} from '../platform.service';
import {Graphic, GraphicService} from '../../graphic/graphic.service';
import {Observable} from 'rxjs';
import {first} from 'rxjs/operators';
import {PriceService} from '../price.service';
import {AddOfferings, AddProduct} from '@uofu-uss-aux/software-catalog-ng-core';
import {NgForOf, NgIf} from '@angular/common';
import {RouterLink} from '@angular/router';
import {PlatformComponent} from '../platform/platform.component';
import {PriceComponent} from '../price/price.component';
import {CatalogGraphicComponent} from '../../graphic/catalog-graphic/catalog-graphic.component';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  inputs: ['product', 'studentOfferings', 'employeeOfferings', 'universityOfferings'],
  standalone: true,
  imports: [
    NgIf,
    RouterLink,
    NgForOf,
    PlatformComponent,
    PriceComponent,
    CatalogGraphicComponent
  ]
})
export class ProductComponent extends AddProduct(AddOfferings(Object)) implements OnInit {

  graphic: Graphic;
  lowestPrice: number;
  highestPrice: number;

  constructor(private readonly platformService: PlatformService,
              private readonly graphicService: GraphicService,
              private readonly priceService: PriceService) {
    super();
  }

  ngOnInit(): void {
    if (this.imageId) {
      this.fetchGraphic(this.imageId).pipe(first()).subscribe(next => this.graphic = next);
    }
    const prices = this.priceService.getPriceRange(this.studentOfferings.concat(this.employeeOfferings, this.universityOfferings));
    this.lowestPrice = prices[0];
    this.highestPrice = prices[1];
  }

  private fetchGraphic(id: number): Observable<any> {
    return this.graphicService.fetchGraphic(id);
  }

}

